/**
 * Helper utility for safely importing Capacitor plugins
 * Provides mock implementations for web environments
 */

// Import local mock implementations
import { LocalNotifications as MockLocalNotifications } from './mocks/local-notifications.mock';
import logger from '../utils/logger';

/**
 * Safely import the LocalNotifications module or use a mock implementation
 */
export const getLocalNotificationsModule = async () => {
  try {
    // Try to import the real Capacitor plugin
    return await import('@capacitor/local-notifications');
  } catch (error) {
    logger.info('Using mock LocalNotifications implementation');
    // Return our mock implementation when the real module can't be loaded
    return { LocalNotifications: MockLocalNotifications };
  }
};